import type { GeneratedCaptionSource } from '@/types/timeline'

const GENERATED_CAPTION_SOURCE_TYPES: ReadonlySet<GeneratedCaptionSource['type']> = new Set([
  'transcript',
  'ai-captions',
  'subtitle-import',
  'embedded-subtitles',
])

const REPLACEABLE_CAPTION_SOURCE_TYPES: ReadonlySet<GeneratedCaptionSource['type']> = new Set([
  'transcript',
  'ai-captions',
  'subtitle-import',
  'embedded-subtitles',
])

export function isGeneratedCaptionSourceType(
  sourceType: GeneratedCaptionSource['type'],
): boolean {
  return GENERATED_CAPTION_SOURCE_TYPES.has(sourceType)
}

export function isReplaceableGeneratedCaptionSourceType(
  sourceType: GeneratedCaptionSource['type'],
): boolean {
  return REPLACEABLE_CAPTION_SOURCE_TYPES.has(sourceType)
}